export const REPOSITORY_DATA_SOURCE = {
  DB: 'db',
  GITHUB: 'github',
} as const;

export type RepositoryDataSource =
  (typeof REPOSITORY_DATA_SOURCE)[keyof typeof REPOSITORY_DATA_SOURCE];

export const INSTALLATIONS_DATA_SOURCE = {
  DB: 'db',
  GITHUB: 'github',
} as const;

export type InstallationsDataSource =
  (typeof INSTALLATIONS_DATA_SOURCE)[keyof typeof INSTALLATIONS_DATA_SOURCE];
